module.exports = __webpack_public_path__ + "img/Shattered_Shackle.5a77e340.png";